import { FuelDivider, FuelSkeleton } from '@frete.com/fuel-react';
import { FC } from 'react';

import { Header } from '@/components';

import {
  ActionsContainer,
  FeatureItem,
  FeaturesContainer,
  FooterContainer,
  FooterItem,
  FooterLogoContainer,
} from './styled';

export const Skeleton: FC = () => (
  <>
    <Header title="Gerenciamento de Risco Fretebras" />

    <ActionsContainer>
      {Array.from({ length: 4 }, (_, key) => (
        <FuelSkeleton shape="text" size="custom" width="100%" height="100%" key={key} />
      ))}
    </ActionsContainer>

    <FeaturesContainer>
      {Array.from({ length: 4 }, (_, key) => (
        <FeatureItem key={key}>
          <FuelSkeleton shape="circle" size="xlarge" />
          <FuelSkeleton shape="text" size="large" />
          <div>
            <FuelSkeleton shape="text" size="small" />
            <FuelSkeleton shape="text" size="small" width="88%" />
          </div>
        </FeatureItem>
      ))}
    </FeaturesContainer>

    <FooterContainer>
      <FooterItem>
        <FuelSkeleton shape="text" size="small" width="20rem" />
        <FooterLogoContainer>
          {Array.from({ length: 5 }, (_, key) => (
            <FuelSkeleton shape="pill" size="custom" height="1.5rem" width="5rem" key={key} />
          ))}
        </FooterLogoContainer>
      </FooterItem>
      <FuelDivider orientation="vertical" />
      <FooterItem>
        <FuelSkeleton shape="text" size="small" width="20rem" />
        <FooterLogoContainer>
          <FuelSkeleton shape="pill" size="custom" height="1.5rem" width="5rem" />
        </FooterLogoContainer>
      </FooterItem>
    </FooterContainer>
  </>
);
